<template>
  <div class="endRow pa-1 d-flex align-center flex-wrap">
    <v-menu
      offset-y
      offset-x
      :disabled="$vuetify.breakpoint.mdAndUp"
      rounded="lg"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          outlined
          pill
          :color="endsTypes[rowType].color"
          class="me-2 py-5 pe-4 d-flex justify-center align-center"
          style="min-width: 150px"
          v-if="rowType"
        >
          <v-icon :endsTypes="endRow[rowType].color" class="me-2">
            {{ endsTypes[rowType].icon }}
          </v-icon>
          {{ endsTypes[rowType].title }}
        </v-chip>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-title class="px-3 text-wrap w-100">{{
            getText()
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <div
      v-if="$vuetify.breakpoint.mdAndUp"
      class="grey--text text--darken-2 ifRowText"
    >
      {{ getText() }}
    </div>
  </div>
</template>
<script>
export default {
  name: "endRowContent",
  props: {
    endRow: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      endsTypes: [],
    };
  },
  computed: {
    rowType() {
      if ("end_notify" in this.endRow) {
        return "end_notify";
      } else if ("end_controller" in this.endRow) {
        return "end_controller";
      }
      return null;
    },
    devices() {
      const devices = this.$store.getters["devices/devices"];
      return Object.values(devices);
    },
  },
  created() {
    this.endsTypes = {
      end_notify: {
        title: this.$t("notification"),
        icon: "mdi-bell-outline",
        color: "blue",
      },
      end_controller: {
        title: this.$t("controller_action"),
        icon: "mdi-chip",
        color: "green",
      },
    };
  },
  methods: {
    device(identifier) {
      return this.devices && identifier
        ? this.devices.filter((d) => d.identifier == identifier)[0]
        : null;
    },
    getText() {
      let text = "";
      // console.log("end_notify", this.endRow.end_notify.not);
      if ("end_notify" in this.endRow) {
        text = this.$t("sendMsg") + " " + this.$t("via") + " ";
        text += this.endRow.end_notify.not
          .map((channel) => {
            return this.$t(channel == "email" ? "emailNot" : channel);
          })
          .join(", ");
      } else if ("end_controller" in this.endRow) {
        const device = this.device(this.endRow.end_controller);
        text = device.name ? device.name : device.identifier;
        text += " - " + this.$t(this.endRow.end_action);
      }
      return text;
    },
  },
};
</script>
<style lang="scss" scoped>
.ifRowText {
  line-height: 1.1;
}
</style>
